// NB!: This file needs rework
/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { Link } from "@reach/router";
import { useQuery } from "@apollo/client";
import MaterialTable from "@material-table/core";
import { Grid, Tooltip } from "@material-ui/core";
import { FetchManualContactsView,
  FetchManualContactsViewVariables,
  FetchManualContactsView_interestList_scheduledUpdate_manualContacts_results as RequestedResult } from "types/gql-types";
import { Viewer } from "components/auth/types";
import Text from "components/text";
import { ContactColumn, NameColumnRaw, PhoneColumn, ReasonColumn } from "pages/waitlist-update/dashboard/components/custom-columns";
import { ContainerCardLayout } from "components/haven-design";
import { IconButton } from "components/haven-design/icon-button";
import { useTablesRef } from "components/table-refs";
import { QUERY_MANUAL_CONTACTS } from "../query";
import ModalForm from "./modal-form";

interface Props {
  list?: string;
  path: string;
  viewer: Viewer;
}

interface ApplicantData {
  address1: string;
  address2: string;
  city: string;
  email: string;
  householdCount: number;
  householdNetIncome: number;
  primaryPhone: string;
  state: string;
  zip: string;
}

export interface FormValues {
  applicant: Partial<ApplicantData>;
  disposition: string;
  notes: string;
  removalReason: string;
  result: null | "update" | "remove";
}

const DEFAULT_PAGE_SIZE = 10;

const tableOptions = {
  sorting: false,
  showTitle: false,
  pageSize: DEFAULT_PAGE_SIZE,
  pageSizeOptions: [10, 20, 50],
  paginationType: "stepped" as const,
  search: true,
  toolbar: true,
  padding: "dense" as const,
};

const WaitlistUpdateContact: React.FC<Props> = (props) => {
  const [viewing, setViewing] = useState<RequestedResult | null>(null);
  const [lastViewing, setLastViewing] = useState<string | null>(null);
  const setViewingAndLast = (data: RequestedResult | null) => {
    setViewing(data);
    if (data?.interestId) setLastViewing(data.interestId);
  };

  const [totalCount, setTotalCount] = React.useState(0);
  const { manualContactTableRef } = useTablesRef();
  const { data, loading, fetchMore } = useQuery<FetchManualContactsView,
  FetchManualContactsViewVariables>(
    QUERY_MANUAL_CONTACTS,
    { variables: { id: props.list ?? "", limit: 10, offset: 0 }, notifyOnNetworkStatusChange: true },
  );

  if (!data) return null;
  if (!props.list) return null;
  const { interestList: { scheduledUpdate: { manualContacts: { results } } } } = data;

  const cardTitle = () => (<>
    <Link to={`/dash/manager/update/${data.interestList.id}`}>
      {data.interestList.name} Waitlist Update
    </Link>&nbsp;&ndash; Manual contact</>);

  // @ts-ignore
  const refreshTable = () => tableRef.current?.onQueryChange();

  return (
    <ContainerCardLayout title={cardTitle()}>
      <Grid container>
        <Grid container item lg={5} md={7} sm={12}>
          <Text type="light">
                  There are {totalCount} applicants who could not be contacted by Haven
                  Connect due to insufficient or invalid contact information.
          </Text>
        </Grid>
        <Grid item lg={7} md={5} sm={12} container justifyContent="flex-end">
          <Grid item>
            <Tooltip title="Refresh">
              <div>
                <IconButton
                  type="refresh"
                  loading={loading}
                  onClick={refreshTable}
                />
              </div>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
      <MaterialTable<RequestedResult>
        tableRef={manualContactTableRef}
        components={{ Container: Grid }}
        columns={[
          { title: "Name", field: "name", render: (rowData) => <NameColumnRaw {...rowData} /> },
          { title: "Reason", field: "name", render: (rowData) => <ReasonColumn {...rowData} /> },
          { title: "Phone", field: "phone", render: (rowData) => <PhoneColumn value={rowData.phones[0]?.number ?? ""} /> },
          { title: "Contact",
            field: "id",
            render: (rowData) => <ContactColumn onContact={() => {
              setViewingAndLast(rowData);
            }} /> },
        ]}
        data={({ page, pageSize, search }) => {
          const limit = pageSize;
          const offset = page * limit;
          return fetchMore({
            variables: {
              search,
              offset,
              limit,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              return fetchMoreResult;
            },
          }).then((res) => {
            const {
              results: newRows, totalCount: newTotalCount,
            } = res.data.interestList.scheduledUpdate.manualContacts;

            setTotalCount(newTotalCount);
            return {
              data: newRows,
              page,
              totalCount: newTotalCount,
            };
          });
        }}
        options={{
          ...tableOptions,
          rowStyle (rowData) {
            if (rowData.interestId === lastViewing) {
              return { borderLeft: "2px solid #F54E01",
                backgroundColor: "#F5FBFC" };
            }
            return {};
          },
        }}
      />
      <ModalForm
        applicants={results}
        viewing={viewing}
        setViewing={setViewingAndLast}
      />
    </ContainerCardLayout>
  );
};

export default WaitlistUpdateContact;
